<div class="scootaverses-modal">
  <div class="close-button-container">
    <h2 class="social-dialog-title" mat-dialog-title>Scootaverses</h2>
    <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="closeModal()"
      >close</mat-icon
    >
  </div>
  <div class="subtitle">
    Select a Scootaverse from your list of existing Scootaverses, or create a new one for your event.
  </div>
  <mat-dialog-content infiniteScroll [infiniteScrollDistance]="3" (scrolled)="onScroll()" [scrollWindow]="false">
    <div class="scootaverse-container">
      @if (!roomSets.length && !this.loading) {
        <no-scootaverses-page></no-scootaverses-page>
      } @else {
        <div class="scootaverse-list">
          @for (set of roomSets; track set) {
            <scootaverse-card
              [roomSet]="set"
              [attachPage]="true"
              (selectedRoom)="onSelectRoom($event)"
            ></scootaverse-card>
          }
          @if (!this.loading) {
            <create-scootaverse></create-scootaverse>
          }
        </div>
      }
    </div>
  </mat-dialog-content>
</div>
